import React from 'react';
import { StyleSheet, css } from 'aphrodite'

import PortfolioItem from '../../Utilities/PortfolioItem'
import NfcAndIot from './NfcAndIot'
import SkewBg from './SkewBg'
//Images
import ImgSelfieStand from '../../../assets/portfolio/IoT/LemonSelfie.png'
import ImgBand from '../../../assets/portfolio/IoT/LemonBand.png'
import ImgCards from '../../../assets/portfolio/IoT/LemonCards.png'
import ImgTerminal from '../../../assets/portfolio/IoT/LemonPayment.png'
import ImgTablet from '../../../assets/portfolio/IoT/LemonTablet.png'
import ImgSticker from '../../../assets/portfolio/IoT/LemonStickers.png'
import ImgLemonBeer from '../../../assets/portfolio/IoT/LemonBeer.png'
import ImgLemonDrinks from '../../../assets/portfolio/IoT/LemonDrinks.png'



export default class IndexNfcAndIot extends React.Component{
 render(){
  return(
    <section id="NfcAndIot" className="MainContainer">
    <SkewBg />
     <div className={css(styles.MainDiv)}>
     <NfcAndIot />
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="370px" rowDirection="row-reverse" alignText="left" alignImg="center" img={ImgSelfieStand} title="Selfie Stand" subtitle="NFC Integrated Selfie Stand" textNoLink="Lemon Selfie allows the user to take a photo supporting the same device. Once taken, you can choose to save it or take another one."/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="250px" rowDirection="" alignText="right" alignImg="center" img={ImgBand} title="LemonTags Bracelet" subtitle="NFC Integrated Bracelet" textNoLink="Silicone, fabric or vinyl bracelets. Submersible in water, with logo printing and adjustable! Includes NFC chip"/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="250px" rowDirection="row-reverse" alignText="left" alignImg="center" img={ImgCards} title="LemonTags Cards" subtitle="NFC Cards" textNoLink="PVC cards with NFC tag and customizable stickers with NFC tag."/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="250px" rowDirection="" alignText="right" alignImg="center" img={ImgTerminal} title="LemonTags Terminal" subtitle="NFC Terminal" textNoLink="Loading and registration terminals. They allow to load balance in the devices in an instantaneous way."/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="320px" rowDirection="row-reverse" alignText="left" alignImg="center" img={ImgTablet} title="LemonTags Tablet" subtitle="NFC Tablet" textNoLink="Fast and secure access, effectively controls the access of guests to your event through a device"/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="190px" rowDirection="" alignText="right" alignImg="center" img={ImgSticker} title="LemonTags Sticker" subtitle="LemonTags Sticker" textNoLink="PVC cards with NFC tag and customizable stickers with NFC tag."/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="250px" rowDirection="row-reverse" alignText="left" alignImg="center" img={ImgLemonBeer} title="Lemon Beer" subtitle="Automated Beer Dispenser" textNoLink="Self-service beer. In order to increase sales, increase the speed of transactions, decrease the long lines and lighten the work to employees."/>
      <PortfolioItem colorTitle="white" colorSubtitle="white" colorText="white" height="340px" rowDirection="" alignText="right" alignImg="center" img={ImgLemonDrinks} title="Lemon Drinks" subtitle="Automated Drink Dispenser" textNoLink="Self-service Drinks. In order to increase sales, increase the speed of transactions, decrease the long lines and lighten the work to employees."/> 
     </div>
    </section>
  );
 }
}

const styles = StyleSheet.create({
  MainContainer: {
    position: 'relative',
  },
	MainDiv : {
    paddingTop: '18em',
    margin: '0 auto',
       maxWidth: 850,
   '@media (max-width: 768px)' :{
      textAlign: 'center',
      paddingTop: '8em',
   }
	}
})


// WEBPACK FOOTER //
// ./src/Components/Portfolio/NfcAndIot/IndexNfcAndIot.js